import { render, staticRenderFns } from "./AuthSetting.vue?vue&type=template&id=50da3995&scoped=true&"
import script from "./AuthSetting.vue?vue&type=script&lang=js&"
export * from "./AuthSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50da3995",
  null
  
)

export default component.exports